<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
  import Accordion from '../components/Accordion.svelte'
  import Chart1 from '../charts/ReachAndFrequency.svelte'
  import Chart2 from '../charts/IncrementalReach.svelte'
  import Chart3 from '../charts/TargetAudience.svelte'
  import Chart4 from '../charts/CustomerOutcomes.svelte'

  let accordionGroupEl

</script>
<section class="part7">
  <div class="rgrid-md-1-2">
    <div class="col">
      <AnimatedTitle class="medium">Better transparency. Better control. Better results.</AnimatedTitle>
      <AnimatedBlock>
        <p class="subtitle">Access the insights you need through the Verizon Media DSP.</p>
      </AnimatedBlock>
    </div>
    <div class="col">
      <div class="charts" bind:this={accordionGroupEl}>
        <Accordion title="Reach & Frequency" id="insight_reach_freq" groupTriggerEl={accordionGroupEl} index={0}>
          <Chart1 />
        </Accordion>
        <Accordion title="Incremental Reach" id="insight_incremental_reach" groupTriggerEl={accordionGroupEl} index={1}>
          <Chart2 />
        </Accordion>
        <Accordion title="Target Audience" id="insight_target_audience" groupTriggerEl={accordionGroupEl} index={2}>
         <Chart3 />
        </Accordion>
        <Accordion title="Customer Outcomes" id="insight_customer_outcomes" groupTriggerEl={accordionGroupEl} index={3}>
          <Chart4 />
        </Accordion>
      </div>
    </div>
  </div>
</section>

<style>
  .charts {
    margin-top: 3.25rem;
  }
  .part7 :global(.subtitle) {
    font-weight: 500;
  }
  .charts :global(.accordion:not(:last-child)) {
    border-bottom-width: 0;
  }
  @media(min-width: 768px) {
    .charts {
      margin-top: 0;
    }
  }
</style>